import { render, staticRenderFns } from "./model-business.vue?vue&type=template&id=62a086aa&scoped=true&"
import script from "./model-business.vue?vue&type=script&lang=js&"
export * from "./model-business.vue?vue&type=script&lang=js&"
import style0 from "./model-business.vue?vue&type=style&index=0&id=62a086aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a086aa",
  null
  
)

export default component.exports